if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector(`[data-slider="${this.sectionID}"]`);
        this.buttonPrev = this.querySelector(`[data-prev="${this.sectionID}"]`);
        this.buttonNext = this.querySelector(`[data-next="${this.sectionID}"]`);
        if (!this.slider) return;

        this.initSlider();
      }

      get sectionID() {
        return this.dataset.sectionId;
      }

      initSlider() {
        const options = {
          slidesPerView: 1.2,
          slidesPerMove: 1,
          spaceBetween: 5,
          pagination: false,
          watchSlidesProgress: true,
          watchOverflow: true,
          loop: true,
          navigation: {
            nextEl: this.buttonNext,
            prevEl: this.buttonPrev,
          },
          breakpoints: {
            541: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2.5,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          },
        };

        const slider = new Swiper(this.slider, options);
      }
    }
  );
}
